/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV1Auth2FaDisablePost } from '../fn/auth-2-fa/api-v-1-auth-2-fa-disable-post';
import { ApiV1Auth2FaDisablePost$Params } from '../fn/auth-2-fa/api-v-1-auth-2-fa-disable-post';
import { apiV1Auth2FaPreferencePatch } from '../fn/auth-2-fa/api-v-1-auth-2-fa-preference-patch';
import { ApiV1Auth2FaPreferencePatch$Params } from '../fn/auth-2-fa/api-v-1-auth-2-fa-preference-patch';
import { apiV1Auth2FaTotpSetupConfirmPost } from '../fn/auth-2-fa/api-v-1-auth-2-fa-totp-setup-confirm-post';
import { ApiV1Auth2FaTotpSetupConfirmPost$Params } from '../fn/auth-2-fa/api-v-1-auth-2-fa-totp-setup-confirm-post';
import { apiV1Auth2FaTotpSetupStartPost } from '../fn/auth-2-fa/api-v-1-auth-2-fa-totp-setup-start-post';
import { ApiV1Auth2FaTotpSetupStartPost$Params } from '../fn/auth-2-fa/api-v-1-auth-2-fa-totp-setup-start-post';
import { SuccessResponse as ModelsSuccessResponse } from '../models/models/success-response';

@Injectable({ providedIn: 'root' })
export class Auth2FaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV1Auth2FaDisablePost()` */
  static readonly ApiV1Auth2FaDisablePostPath = '/api/v1/auth/2fa/disable';

  /**
   * Disable 2FA.
   *
   * Disables 2FA for the authenticated user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1Auth2FaDisablePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1Auth2FaDisablePost$Response(params?: ApiV1Auth2FaDisablePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1Auth2FaDisablePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Disable 2FA.
   *
   * Disables 2FA for the authenticated user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1Auth2FaDisablePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1Auth2FaDisablePost(params?: ApiV1Auth2FaDisablePost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1Auth2FaDisablePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1Auth2FaPreferencePatch()` */
  static readonly ApiV1Auth2FaPreferencePatchPath = '/api/v1/auth/2fa/preference';

  /**
   * Update 2FA preference.
   *
   * Updates the authenticated user's preferred 2FA method.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1Auth2FaPreferencePatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1Auth2FaPreferencePatch$Response(params: ApiV1Auth2FaPreferencePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1Auth2FaPreferencePatch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update 2FA preference.
   *
   * Updates the authenticated user's preferred 2FA method.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1Auth2FaPreferencePatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1Auth2FaPreferencePatch(params: ApiV1Auth2FaPreferencePatch$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1Auth2FaPreferencePatch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1Auth2FaTotpSetupConfirmPost()` */
  static readonly ApiV1Auth2FaTotpSetupConfirmPostPath = '/api/v1/auth/2fa/totp/setup/confirm';

  /**
   * Confirm TOTP setup.
   *
   * Confirms a TOTP code and enables TOTP as the preferred 2FA method.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1Auth2FaTotpSetupConfirmPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1Auth2FaTotpSetupConfirmPost$Response(params: ApiV1Auth2FaTotpSetupConfirmPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1Auth2FaTotpSetupConfirmPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Confirm TOTP setup.
   *
   * Confirms a TOTP code and enables TOTP as the preferred 2FA method.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1Auth2FaTotpSetupConfirmPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1Auth2FaTotpSetupConfirmPost(params: ApiV1Auth2FaTotpSetupConfirmPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1Auth2FaTotpSetupConfirmPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1Auth2FaTotpSetupStartPost()` */
  static readonly ApiV1Auth2FaTotpSetupStartPostPath = '/api/v1/auth/2fa/totp/setup/start';

  /**
   * Start TOTP setup.
   *
   * Generates a TOTP secret and provisioning URI for Google Authenticator-compatible apps.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1Auth2FaTotpSetupStartPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1Auth2FaTotpSetupStartPost$Response(params?: ApiV1Auth2FaTotpSetupStartPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1Auth2FaTotpSetupStartPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Start TOTP setup.
   *
   * Generates a TOTP secret and provisioning URI for Google Authenticator-compatible apps.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1Auth2FaTotpSetupStartPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1Auth2FaTotpSetupStartPost(params?: ApiV1Auth2FaTotpSetupStartPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1Auth2FaTotpSetupStartPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

}
